export function getImageCdn(imageId) {
    return "https://cdn.filestackcontent.com/" + imageId;
}






/** WEBPACK FOOTER **
 ** ./src/Constants.js
 **/